import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "@/features/auth/services/api";
import { useAuthStore } from "@/features/auth/store/useAuth";

export const useLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();

  const login = async (username: string, password: string) => {
    setLoading(true);
    setError(null);
    try {
      const result = await authService.login(username, password);
      setAuth({ username }, result.token);
      navigate("/dashboard", { replace: true });
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Login failed";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return { login, loading, error };
};
